export default __webpack_public_path__ + "static/a7211adbec24d9f8b2de62f8e6663ceb.jpg";